import { useState } from "#imports";

const STORAGE_KEY = "navbar_collapsed";

// localStorage throws when the browser blocks site data (private mode, strict settings).
function readStoredCollapsed(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

function storeCollapsed(collapsed: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, String(collapsed));
  } catch {
    // The choice then only lasts until the next reload.
  }
}

export const useNavbar = () => {
  const isCollapsed = useState<boolean>("navbar_collapsed", readStoredCollapsed);

  const toggleCollapsed = (): void => {
    isCollapsed.value = !isCollapsed.value;
    storeCollapsed(isCollapsed.value);
  };

  return { isCollapsed, toggleCollapsed };
};
